// src/terms/Barrierefreiheit.jsx
import React from "react";
import { ReactComponent as BFSG_icon } from "../icons/BFSG_icon.svg";


export function Barrierefreiheit() {
  const wrap = {
    borderRadius: 12,
    background: "#1B202B",
    border: "1px solid rgba(77,100,141,0.9)",
    boxShadow:
      "inset 0 1px 0 rgba(255,255,255,.04), 0 8px 18px rgba(0,0,0,.85)",
    padding: "16px 18px 18px",
    boxSizing: "border-box",
    height: "100%",
    overflowY: "auto",
  };

  const h1 = {
    fontFamily: "DisplayBadge, system-ui, sans-serif",
    fontSize: "var(--fs-18, 18px)",
    letterSpacing: ".18em",
    textTransform: "uppercase",
    color: "#ff8800",
    margin: "0 0 12px",
  };

  const h2 = {
    fontSize: "var(--fs-12, 12px)",
    letterSpacing: ".1em",
    textTransform: "uppercase",
    marginTop: 15,
    marginBottom: 0,
    color: "#82c3ff",
  };

  const p = {
    fontSize: "var(--fs-12, 12px)",
    lineHeight: 1.1,
    color: "rgba(220,230,245,0.88)",
    margin: "1px 0",
  };

  const small = {
    fontSize: 12,
    lineHeight: 1.5,
    color: "rgba(180,190,210,0.75)",
    marginTop: 10,
  };

  const codeBox = {
    fontFamily: " DisplayBadge ",
    fontSize: 11,
    background: "rgba(0,0,0,0.25)",
    borderRadius: 2,
    padding: "6px 8px",
    marginTop: 6,
    marginBottom: 6,
  };

  return (
    <div style={wrap}>
     <h1 style={{
    ...h1,
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginBottom: 30,
  }}
>
  <BFSG_icon
    width={28}
    height={28}
    aria-hidden="true"
    style={{ flexShrink: 0, transform: "translateY(-0.5px)" }}
  />
  <span>Gesetzliche Information zur Barrierefreiheit</span></h1>

      {/* Anbieter */}
      <h2 style={h2}>Konzept & Projektierung</h2>
      <p style={p}>mts individual® engagiert sich aktiv für digitale Barrierefreiheit und verfolgt das Ziel, allen Menschen – 
       einschließlich Nutzerinnen und Nutzern mit Beeinträchtigungen – einen möglichst uneingeschränkten Zugang zu unseren digitalen 
       Angeboten zu ermöglichen. Dabei setzen wir die gesetzlichen Anforderungen des Barrierefreiheitsstärkungsgesetzes (BFSG) und der 
       zugehörigen Verordnung nicht nur im Rahmen unserer technischen Möglichkeiten konsequent um, sondern integrieren barrierefreie 
       Konzepte bereits frühzeitig und fortlaufend in unsere Entwicklungsprozesse.
       <br />
       <br />
       Unser Anspruch geht dabei bewusst über das gesetzlich geforderte Mindestmaß hinaus:
       <br /> 
       Unser Team entwickelt Funktionen und Interaktionskonzepte gemeinsam mit Personen, die selbst auf barrierefreie Lösungen angewiesen
      sind und deren Erfahrung wertvolle Einblicke liefert. So entsteht ein digitales Produkt, das nicht nur formal barrierearm gestaltet ist,
      sondern die tatsächliche Nutzungserfahrung für möglichst viele Menschen verbessert — dynamisch, innovativ, nachhaltig und praxisnah.
       </p>
      
      
      {/* Vertretungsberechtigter */}
      <h2 style={h2}>1. Beschreibung unserer Services</h2>
      <p style={p}>Die Website Legendstools bietet verschiedene digitale Werkzeuge und Informationsdienste rund um strategische Spielwelten (insbesondere browserbasierte Aufbauspiele). 
      Zu den zentralen Funktionen gehören unter anderem:</p>
      <br />
      
      <p style={p}>
      • eine interaktive Kartenansicht („Map“),
      <br />
      • statistische Auswertungen zu Spielwelten, Allianzen und Spielern,
      <br />
      • Analyse- und Planungstools für offensive und defensive Szenarien,
      <br />
      • Account- und Verwaltungselemente,
      <br />
      • sowie ergänzende Informations- und Hilfeseiten.
      </p>
      
      <br />
      <p style={p}>Alle Funktionen sind so gestaltet, dass Nutzerinnen und Nutzer jederzeit eine klare Orientierung erhalten 
      und die jeweiligen Werkzeuge über ein einheitliches Bedienkonzept erreichen können.</p>
      <br />
      <p style={p}>Da die Plattform fortlaufend weiterentwickelt wird, können Funktionsumfang, Darstellung oder Bedienlogik 
      sich im Laufe der Zeit verändern. Neue Module werden so gestaltet, dass sie die bestehenden barrierearmen Grundprinzipien
      berücksichtigen und keine Verschlechterung der Zugänglichkeit verursachen.</p>



      {/* 3. COOKIES */}
      <h2 style={h2}>2. Stand der Vereinbarkeit mit dem BFSG</h2>
      <p style={p}>Diese Website ist teilweise barrierefrei gemäß den Vorgaben der Barrierefreie-Websites-Verordnung (BFWVO) 
      und den Anforderungen der WCAG 2.1 (Level AA).</p>

      {/* 4. KONTAKT */}
      <h2 style={h2}>3. Funktionen, die die Barrierefreiheit unterstützen, unter anderem:</h2>
      <p style={p}>
      3.1 TracePad – Bedienung ohne komplexe Fingergesten auf Mobilgeräten
      <br />
      Für mobile Nutzer:innen haben wir ein eigenes Bedienkonzept entwickelt:
      TracePad, ein Gesten-Ersatz, der Drag-Bewegungen, Zooms und Aktionen vereinfacht, ohne dass schwierige Finger-Kombinationen notwendig sind.
      Dies erleichtert die Nutzung für Menschen mit motorischen Einschränkungen oder unpräziser Touch-Steuerung.
      </p>
      <br />
      <p style={p}>
        3.2 Konsequent farbcodierte Benutzeroberfläche
      <br />
      Die UI folgt einem klaren Farbleitsystem:
      <br />
      • wiederkehrende Funktionen sofort erkennbar macht
      <br />
      • Bedienbereiche visuell voneinander trennt
      <br />
      • kognitive Last reduziert
      <br />
      • auch bei leichter Farbfehlsichtigkeit verständlich bleibt
      </p>
      <br />
      <p style={p}>
        3.3 Piktogramme zur Reduzierung von Textkörpern
      <br />
      Viele Bedienelemente sind (teils zusätzlich) mit einfachen, klar erkennbaren Symbolen versehen, die auch ohne Sprachkenntnisse verständlich sind.
      Die Symbole wurden explizit so gestaltet, dass sie intuitiv und universell wirken.
      </p>
      <br />
      <p style={p}>
        3.4 Hohe Lesbarkeit & adaptive Schriftgrößen
      <br />
      Mit dem integrierten Schriftgrößenpanel "AAA" können Nutzer:innen die Textgröße in drei Stufen sofort ohne Umweg anpassen – unabhängig vom Systemzoom.
      <br />
      Alle Typografien wurden nach folgenden Kriterien optimiert:
      <br />
      • Kontrast
      <br />
      • Zeilenabstand
      <br />
      • Wiedererkennbarkeit
      </p>
      <br />
      <p style={p}>
        3.5 Optische Lupe & Zoomhilfen
      <br />
      Dynamische Bereiche wie Karten oder Detail-Module bieten Lupen- bzw. Fokuseffekte zur besseren Orientierung.
      Diese helfen Nutzer:innen mit eingeschränktem Sehfeld oder verminderter Tiefenwahrnehmung.
      </p>
      <br />
      <p style={p}>
        3.6 Beta-Phase mit realen Nutzergruppen
      <br />
      Legendstools wurde in frühen Stadien mit folgenden Usergruppen erprobt:
      <br />
      • Senior:innen,
      <br />
      • Nutzer:innen mit Farbfehlsichtigkeit,
      <br />
      • Nutzer:innen mit motorischen Einschränkungen
      </p>
      <br />
      <p style={p}>
        3.7 Verzicht auf Cookie-Banner zur Entlastung
      <br />
      Legendstools verzichtet auf Tracking-Cookies und setzt nur technisch notwendige Session-Daten ein.
      Dadurch entfällt ein Cookie-Banner, was die Nutzung für Menschen mit kognitiven Beeinträchtigungen erleichtert und Ablenkung reduziert.
      </p>
      <br />
      <p style={p}>
        3.8 Starke Kontraste & eindeutige visuelle Schwerpunkte
      <br />
      Alle interaktiven Elemente werden durch Kontrast, Schatten und klare, räumliche Tiefeneffekte hervorgehoben.
      Unseres Erachtens nach ist Barrierefreiheit nicht nur "Screenreader" – sie ist  auch "visuelle Klarheit".
      </p>
      <br />
      <p style={p}>  
        3.9 Robustheit
      <br />
      Legendstools basiert auf einer modularen, zukunftsfähigen Architektur. Kernfunktionen wie Karten-Rendering, API-Datenfluss, UI-Komponenten und Datenverarbeitung 
      sind derart konzipiert, dass sie auch bei Änderungen an Browsertechnologien, Devices oder Assistenzsystemen stabil funktionieren. Durch kontinuierliche Tests und 
      Refactoring wird die langfristige Nutzbarkeit der Plattform sichergestellt.
      </p>
     
      <h2 style={h2}>4. Aktuelle Einschränkungen der Barrierefreiheit</h2>
      <p style={p}>
      Trotz der bereits umgesetzten Maßnahmen erfüllt Legendstools derzeit noch nicht alle Anforderungen der Barrierefreie-Websites-Verordnung (BFWVO) und der WCAG 2.1 (AA).
      Die folgenden Bereiche befinden sich aktiv in Überarbeitung oder sind aufgrund ihrer Komplexität noch nicht vollständig barrierefrei:
      <br />
      <br />
      • 4.1 Dynamische Karten- und Statistikmodule
      <br />
      Einige Inhalte, insbesondere dynamische Statistiken, Heatmaps oder große Tabellenstrukturen, sind aufgrund ihrer hohen Informationsdichte nur eingeschränkt barrierefrei darstellbar.
      Wir arbeiten daran, diese Darstellungen schrittweise um zusätzliche visuelle Hilfen, alternative Ansichten und besser strukturierte Details zu erweitern.
      Für Nutzer:innen mit Screenreader oder rein tastaturbasierter Bedienung kann die Nutzung dieser visuellen Diagramme derzeit nur eingeschränkt erfolgen.
      <br />
      <br />
      • 4.2 Screenreader-Interpretation einzelner UI-Bereiche
      <br />
      Obwohl viele UI-Elemente semantisch korrekt ausgezeichnet sind, können Screenreader bestimmte Komponenten (z. B. interaktive Kartensegmente, dynamische Panels oder künstlich erzeugte Canvas-Bereiche) nur begrenzt interpretieren.
      Dies ist eine systembedingte Einschränkung bei Anwendungen, die grafische Oberflächen und Canvas-Rendering verwenden.
      Wir entwickeln derzeit zusätzliche Beschriftungen, ARIA-Hinweise und alternative Zugänge für zentrale Funktionen, sodass die Barrierefreiheit kontinuierlich verbessert wird.
      <br />
      <br />
      • 4.3 Mobile Nutzung
      <br />
      Legendstools ist derzeit für Desktop- und Tablet-Geräte optimiert. Die Nutzung auf Smartphones ist grundsätzlich möglich, jedoch aufgrund der Informationsdichte
      nur eingeschränkt komfortabel. Eine optimierte mobile Version befindet sich in Planung.
      </p>
      <h2 style={h2}>5. Feedback & Kontakt zur Barrierefreiheit</h2>
      <p style={p}>
      Hilf uns, die Zugänglichkeit weiter zu verbessern.
      mts individual® optimiert kontinuierlich die barrierefreie Gestaltung der Website und ihrer Anwendungen.
      Wenn Du während der Nutzung auf Barrieren stößt oder Hinweise bzw. Anregungen hast, freuen wir uns über Deine Rückmeldung.

      Du erreichst uns unter:
      <br />
      <br />
      📧 E-Mail:
      <br />
      barrierefreiheit@legendstools.de
      <br />
      <br />
      📞 Telefon:
      <br />
      +49 (0551) 291 250 30
      <br />
      <br />
      📨 Postanschrift:
      <br />
      mts individual carstyling GmbH
      <br />
      Abt.: Barrierefreiheit / Legendstools
      <br />
      Rilkestrasse 32b
      <br />
      37120 Bovenden
      <br />
      Deutschland
      </p>


      <h2 style={h2}>6. Zuständige Marktüberwachungsbehörde</h2>
      <p style={p}>
      Die zuständige Marktüberwachungsbehörde für Fragen der Einhaltung der Barrierefreiheitsanforderungen ist die Marktüberwachungsstelle 
      der Länder für die Barrierefreiheit von Produkten und Dienstleistungen mit Sitz in Sachsen-Anhalt:
      <br />
      <br />
      Kontakt:
      <br />
      MLBF AöR
      <br />
      c/o Ministerium für Arbeit, Soziales, Gesundheit und Gleichstellung Sachsen-Anhalt
      <br />
      Postfach: 39 11 55
      <br />
      39135 Magdeburg
      <br />
      Telefon: 0391 567 6970
      <br />
      E-​Mail: MLBF@ms.sachsen-​anhalt.de
      <br />
      </p>
      <br />
      <br />



      <div style={small}>
      © 2025 mts individual carstyling GmbH, Germany. Alle Rechte vorbehalten.
      <br />
      Legendstools ist ein digitales Angebot der mts individual carstyling GmbH.
      mts individual® ist eingetragenes Warenzeichen der mts individual carstyling GmbH.
      </div>
    </div>
  );
}


